import React from 'react'
import { FormattedHTMLMessage, Modal, ModalProps } from '@web/walter-ui-kit'
import Confirmation, { Props as ConfirmationProps } from './Confirmation'
import { lang } from '~components/ConfirmationModal/Confirmation/lang'

interface Props extends ConfirmationProps, Pick<ModalProps, 'size'> {
    isOpen: boolean
    onClose: () => void
    isLoading?: boolean
}

function ConfirmationModal({
    isOpen,
    onClose,
    onSuccess,
    showVerificationCode,
    resource,
    showTwoFa,
    isLoading,
    size,
}: Props) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            dataPointer="confirmation_modal"
            title={<FormattedHTMLMessage {...lang.title} />}
            size={size}
        >
            <Confirmation
                resource={resource}
                onSuccess={onSuccess}
                isLoading={isLoading}
                showVerificationCode={showVerificationCode}
                showTwoFa={showTwoFa}
                initialInputState="pending"
            />
        </Modal>
    )
}

export default ConfirmationModal
export type { ConfirmModalState } from './types'
